import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  CROSS_SELLING_STORE_KEY,
  CrossSellingData,
  CrossSellingState,
} from './cross-selling.state';

export const selectCrossSellingFeature =
  createFeatureSelector<CrossSellingState>(CROSS_SELLING_STORE_KEY);

export const selectCrossSellingData = createSelector(
  selectCrossSellingFeature,
  (state: CrossSellingState) => state.data,
);

export const selectCrossSellingIsLoaded = createSelector(
  selectCrossSellingFeature,
  (state: CrossSellingState) => state.isLoaded,
);

export const selectCrossSellingIsLoading = createSelector(
  selectCrossSellingFeature,
  (state: CrossSellingState) => state.isLoading,
);

export const selectCrossSellingHasError = createSelector(
  selectCrossSellingFeature,
  (state: CrossSellingState) => state.hasError,
);

export const selectCrossSellingError = createSelector(
  selectCrossSellingFeature,
  (state: CrossSellingState) => state.error,
);

export const selectCrossSellingDataByTriggerProductId = (triggerProductId: string) =>
  createSelector(selectCrossSellingData, (data: CrossSellingData | null) =>
    data?.triggerProductId === triggerProductId ? data : null,
  );
